import { Button, styled } from "@mui/material";

export const OutlinedButton = styled(Button)(({ theme }) => ({
    border: `1px solid rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)`,
    padding: `${theme.spacing(1)} ${theme.spacing(1)}`,
    borderRadius: theme.spacing(2),
}));